import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import getUserToken from '../../helpers/tokenValidation'
import { alertActions } from './alertSlice'


const backendURL = process.env.REACT_APP_API_URL;



//this is for register
export const registerUser = createAsyncThunk(
  'auth/register',
  async ({ name, email, password, registration_type, nic }, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const { data } = await axios.post(
        `${backendURL}/api/signup`,
        { name, email, password, registration_type, nic },
        config
      );
      if (!data.requires_verification) {
        const expireDate = new Date();
        expireDate.setHours(expireDate.getHours() + 1);
        localStorage.setItem('userToken', data.access_token);
        localStorage.setItem('tokenExpireDate', expireDate.toISOString());
      }

      dispatch(
        alertActions.createAlert({
          message: data.message || 'User Registration Successful !!!',
          type: 'success',
        })
      )
      return data;
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: 'warning',
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);

//This is for Login
export const userLogin = createAsyncThunk(
  'auth/login',
  async ({ email, password }, { rejectWithValue, dispatch }) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data } = await axios.post(
        `${backendURL}/api/login`,
        { email, password },
        config
      )

      const expireDate = new Date();
      expireDate.setHours(expireDate.getHours() + 1);
      localStorage.setItem('userToken', data.access_token)
      localStorage.setItem('tokenExpireDate', expireDate.toISOString());
      // STORE USER IDS
      localStorage.setItem('user_id', data.user_id);       // logged-in user
      localStorage.setItem('user_name', email);
      localStorage.setItem('user_role', data.role || 'user'); // Store role
      console.log('jj1', data.email)     // profile/detail user
      dispatch(
        alertActions.createAlert({
          message: 'Login Success !!!',
          type: "success",
        })
      );
      return data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(errorMessage);
    }
  }
)

export const verifyIdentityCard = createAsyncThunk(
  'auth/verifyIdenticard',
  async ({ nic, name, email }, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const { data } = await axios.post(
        `${backendURL}/api/verifyIdenticard`,
        { nic, name, email },
        config
      );
      return data
    }
    catch (error) {
      const errorMessage = error.response?.data?.message || error.message;

      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: 'warning',
        })
      );

      return rejectWithValue(errorMessage)
    }
  }
)
export const userProfile = createAsyncThunk(
  'auth/profile',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      // configure header's Content-Type as JSON
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,

        },
      }
      const { data } = await axios.get(
        `${backendURL}/api/profile`,
        config
      )
      return data
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      return rejectWithValue(errorMessage)
    }
  }
)
// getting users Details
export const fetchUserDetails = createAsyncThunk(
  'auth/fetchUserDetails',
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,
        },
      }
      const { data } = await axios.get(
        `${backendURL}/api/userDetails`,
        config
      )
      return data
    }
    catch (error) {
      return [];
    }
  }
)
// getting users Details
export const fetchUserSpecificData = createAsyncThunk(
  'auth/fetchUserSpecificData',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,
        },
      }
      const { data } = await axios.get(
        `${backendURL}/api/userSpecificDetails?userId=${arg}`,
        config
      )
      return data
    }
    catch (error) {
      // const errorMessage = error.response && error.response.data.message
      //   ? error.response.data.message
      //   : error.message;
      // dispatch(
      //   alertActions.createAlert({
      //     message: errorMessage,
      //     type: "warning"
      //   })
      // );
      return 0;
    }
  }
)

export const addFavouration = createAsyncThunk(
  'auth/addUserFavour',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const { data } = await axios.post(`${backendURL}/api/addFav?favId=${arg.favId}&favName=${arg.favName}&userId=${arg.userId}`,
        config
      )
      dispatch(
        alertActions.createAlert({
          message: 'Favouration adding Success !!!',
          type: "success",
        })
      );
      return data
    } catch (error) {
      const errorMessage = error.response && error.response.data.message
      //   ? error.response.data.message
      //   : error.message;
      // dispatch(
      //   alertActions.createAlert({
      //     message: errorMessage,
      //     type: "warning"
      //   })
      // );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)

export const removeFavouration = createAsyncThunk(
  'auth/removeFavour',
  async ({ userId, favId }, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`
        }
      };

      const { data } = await axios.delete(
        `${backendURL}/api/remove-favoration/${userId}/${favId}`,
        config
      );

      dispatch(
        alertActions.createAlert({
          message: 'User blocked successfully',
          type: "success",
        })
      );

      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to block user';

      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
)

export const getFavourationList = createAsyncThunk(
  'auth/favourationList',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const { data } = await axios.get(`${backendURL}/api/getFavList?userId=${arg}`, config)
      return data
    }
    catch (error) {
      //   const errorMessage = error.response && error.response.data.message
      //   ? error.response.data.message
      //   : error.message;
      // dispatch(
      //   alertActions.createAlert({
      //     message: errorMessage,
      //     type: "warning"
      //   })
      // );
      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)

export const getDetailsFavList = createAsyncThunk(
  'auth/getDetailsFavList',
  async (arg, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const { data } = await axios.get(`${backendURL}/api/getDetailsFavLists?detailId=${arg}`, config)
      return data
    }
    catch (error) {

      return rejectWithValue(JSON.stringify(error.response.data.message))
    }
  }
)

export const checkFavoriteStatus = createAsyncThunk(
  'auth/checkFavoriteStatus',
  async ({ profileId, viewerId }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`
        }
      }
      const { data } = await axios.get(
        `${backendURL}/api/checkFavoriteStatus/${profileId}/${viewerId}`,
        config
      )
      return data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to check favorite status')
    }
  }
)


// adding or removing permission
// fetch user permission
export const fetchUserPermission = createAsyncThunk(
  "auth/UserPermission",
  async (arg, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json"
        },
      };

      const { data } = await axios.get(
        `${backendURL}/api/permissionCheck?userId=${arg}`,
        config
      );

      return data;
    } catch (error) {
      console.error("Error fetching user permission:", error);

      const errorMessage =
        error.response?.data?.message || "An unexpected error occurred";

      return rejectWithValue(errorMessage);
    }
  }
);




export const userChangePassword = createAsyncThunk(
  'auth/changePassword',
  async ({ currentPassword, newPassword }, { rejectWithValue, dispatch }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getUserToken()}`,
        },
      }
      const { data } = await axios.post(
        `${backendURL}/api/change-password`,
        { currentPassword, newPassword },
        config
      )

      dispatch(
        alertActions.createAlert({
          message: data.message || 'Password Changed Successfully !!!',
          type: "success",
        })
      );
      return data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch(
        alertActions.createAlert({
          message: errorMessage,
          type: "warning"
        })
      );
      return rejectWithValue(errorMessage);
    }
  }
)
